import React, { useState } from 'react';
import './UserJobsPrevious.css';
import { Job } from '@diditusa/shared/types/jobTypes';
import { format } from 'date-fns';

interface UserJobsPreviousProps {
  sortedJobs: Job[];
}

const serviceOption = (option: number): string => {
  switch (option) {
    case 1:
      return 'Prestige Executive Package';
    case 2:
      return 'Essential Protection Package';
    case 3:
      return 'Signature Protection & Chauffeur Service';
    default:
      return 'N/A';
  }
};

const UserJobsPrevious: React.FC<UserJobsPreviousProps> = ({ sortedJobs }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 10;

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = sortedJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(sortedJobs.length / jobsPerPage);

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const handlePageClick = (page: number) => {
    setCurrentPage(page);
  };

  const paddingRowsCount = jobsPerPage - currentJobs.length;

  return (
    <div className='user-jobs-previous-wrapper'>
      <table className='user-jobs-previous-table'>
        <thead>
          <tr>
            <th>Reservation Number</th>
            <th>Address</th>
            <th>Date</th>
            <th>Time</th>
            <th>Duration</th>
            <th>Service Option</th>
          </tr>
        </thead>
        <tbody>
          {currentJobs.map((job) => (
            <tr key={job.id}>
              <td data-fulltext={String(job.reservationCode)} data-label='Reservation Number'>
                {job.id}
              </td>
              <td data-fulltext={job.location} data-label='Address'>
                {job.location}
              </td>
              <td data-fulltext={job.startTime.toFormat('MM/dd/yyyy')} data-label='Date'>
                {job.startTime.toFormat('MM/dd/yyyy')}
              </td>
              <td data-fulltext={job.startTime.toFormat('hh:mm a ZZZZ')} data-label='Time'>
                {job.startTime.toFormat('hh:mm a ZZZZ')}
              </td>
              <td data-fulltext={`${job.durationHours} Hours`} data-label='Duration'>
                {job.durationHours} Hours
              </td>
              <td data-fulltext={serviceOption(job.securityOptionId)} data-label='Service Option'>
                {serviceOption(job.securityOptionId)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className='pagination-controls'>
        <button onClick={handlePrevious} disabled={currentPage === 1}>
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((page) => (
          <button
            key={page}
            onClick={() => handlePageClick(page)}
            className={page === currentPage ? 'active-page' : ''}
          >
            {page}
          </button>
        ))}
        <button onClick={handleNext} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
};

export default UserJobsPrevious;
